import React from 'react';
import FormDialog from '../form/form-dialog';
import http from '../utils/http';

const AcceptedDomainDeleteModal = (props) => {

    const {
        config,
        isOpen,
        onChangeBulk,
        applicationId,
        environmentName,
        acceptedDomain
    } = props;
    return (
        <FormDialog
            dialogTitle={`Delete "${acceptedDomain}" as an accepted domain?`}
            dialogSubHeading={'WARNING: Deleting an accepted domain will prevent the frontend from being matched to an application environment API request. Are you sure?'}
            submitButtonText={'DELETE'}
            handleClose={() => onChangeBulk({ acceptedDomainDeleteModalIsOpen: false })}
            handleSubmit={async () => {
                const application = await http.delete(
                    {},
                    `${config.uri.base}/application/${applicationId}/environment/${environmentName}/domain/${acceptedDomain}`
                );
                onChangeBulk({
                    acceptedDomainDeleteModalIsOpen: false,
                    application: application,
                    environments: application.environments,
                });
            }}
            isOpen={isOpen}
        >
        </FormDialog>
    );
};

export default AcceptedDomainDeleteModal;
